export default {"src":"/_next/static/media/FAQ.84aa8271.svg","height":436,"width":734,"blurWidth":0,"blurHeight":0};